import { AUCTION_API_URL, fmhAPI } from 'api/APIBase';

/** Get all the current bids for an auction by referral ID */
export async function getLiveReferralBids(referralId) {
    const url = `${AUCTION_API_URL}/admin/bids/raw`;
    return fmhAPI.base.url(url).query({ referral_id: referralId }).get().json();
}
